export const aciRun = {
    iconName: 'run',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                d: 'M13.515 12.4l-1.05.242a.347.347 0 00-.323.323l-.242 1.293c-.081.646-.727 1.13-1.373.969-.646-.081-1.131-.727-.97-1.373l.243-1.292c.161-1.131 1.05-2.1 2.261-2.343 4.603-.888 2.907-1.05 5.976 1.373.162.081.323.162.404.081l1.454-.727c.565-.323 1.292-.08 1.615.566.323.565.08 1.292-.565 1.615l-1.454.727c-.404.161-.808.323-1.292.323-.646 0-1.292-.242-1.858-.646l-.484-.404-.566 2.019 1.454.484c.727.323 1.292.889 1.534 1.616.243.727.243 1.534-.08 2.18l-.404 1.05c-.162.485-.646.727-1.13.727-.162 0-.324 0-.485-.08-.646-.243-.889-.97-.646-1.616l.484-1.13c.162-.266.07-.556-.161-.647l-1.535-.565-2.503 4.28c-.243.404-.646.566-1.05.566-.242 0-.404-.081-.646-.162-.565-.323-.808-1.05-.404-1.696l1.938-3.311M7.5 8.905H3.482M7.5 12.924H4.687M7.5 16.943H6.295M16.98 8.846a2.423 2.423 0 110-4.845 2.423 2.423 0 010 4.845z',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-miterlimit': '10',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
